// extracted by mini-css-extract-plugin
module.exports = {"rotate":"Loader_rotate__3QseU","reverse":"Loader_reverse__1NLPi"};